var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStocks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.152 4.971a2.18 2.18 0 012.18 2.18v40.557h43.173a2.18 2.18 0 010 4.361H7.152a2.18 2.18 0 01-2.18-2.18V7.152a2.18 2.18 0 012.18-2.18zM38.986 18.49a2.18 2.18 0 012.18-2.18h9.595a2.18 2.18 0 012.18 2.18v8.722a2.18 2.18 0 11-4.36 0v-6.541h-7.414a2.18 2.18 0 01-2.18-2.18z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.329 16.975a2.18 2.18 0 01-.053 3.083L36.125 35.666a2.18 2.18 0 01-3.03 0l-4.946-4.78L8.667 49.713a2.18 2.18 0 01-3.03-3.136l20.997-20.29a2.18 2.18 0 013.03 0l4.945 4.78 14.637-14.144a2.18 2.18 0 013.083.053z",
    fill: "current"
  })));
}

export default SvgStocks;